// Tiny pub/sub so the sim can announce things (strike, blowout, era change) without importing UI code.
const handlers = new Map();

export function on(type, fn) {
  if (!handlers.has(type)) handlers.set(type, new Set());
  handlers.get(type).add(fn);
  return () => handlers.get(type).delete(fn);
}

export function emit(type, payload) {
  for (const fn of handlers.get(type) ?? []) fn(payload);
  for (const fn of handlers.get('*') ?? []) fn({ type, ...payload });
}
